import React from 'react';
import { getNavIconClass } from '../../../../navigation/clinicNavConfig';

const SIZE_CLASS = {
    xs: 'patient-detail-icon--xs',
    sm: 'patient-detail-icon--sm',
    md: 'patient-detail-icon--md',
    lg: 'patient-detail-icon--lg',
    xl: 'patient-detail-icon--xl',
};

function PatientFilesIcon({ icon, theme = 'primary', size = 'md', className = '', round = false, children }) {
    const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.md;

    return (
        <span
            className={`ecx-nav-icon ${getNavIconClass(theme)} patient-detail-icon patient-files-icon ${sizeClass} ${
                round ? 'patient-detail-icon--round patient-files-icon--round' : ''
            } ${className}`.trim()}
            aria-hidden={children ? undefined : 'true'}
        >
            {icon ? <i className={`bi ${icon}`} /> : null}
            {children}
        </span>
    );
}

export default PatientFilesIcon;
